<template>
	<v-container fluid>
		<!-- <h1 class="title" v-if="paymentData">Reference: {{paymentData.reference}}</h1> -->

		<v-card color="grey lighten-3">
			<v-list-item>
				<!-- 
         <v-list-item-avatar v-if="stallholderData.stallholder_type"
                  :color="getStallholderColor(stallholderData.stallholder_type)"
                  class="headline font-weight-light white--text"
                  >
                  {{ stallholderData.stallholder_type.charAt(0).toUpperCase() }}
                  </v-list-item-avatar> -->

				<v-list-item-content>
					<!-- <v-list-item-subtitle>ID: {{paymentData.id}}</v-list-item-subtitle> -->
					<v-list-item-title class="headline">Reference: {{ paymentData.reference }}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

			<v-list-item>
				<v-list-item-title>Bank Transaction ID: {{ paymentData.transaction_id }} </v-list-item-title>
			</v-list-item>

			<v-list-item>
				<v-list-item-title>Created: {{ paymentData.created_date }} </v-list-item-title>
			</v-list-item>
			<v-list-item>
				<v-list-item-title>Total Amount: {{ paymentData.amount }} </v-list-item-title>
			</v-list-item>

			<v-list-item>
				<strong>History</strong>
			</v-list-item>

			<v-list-item v-for="(h, i) in history" :key="i">
				<div v-for="(his, index) in JSON.parse(h.data)" :key="index" style="margin-right: 20px; margin-top: 20px;">
					<p>
						<strong>Property:</strong>
						{{
							his.property.replace(/_/g, ' ').replace(/\b\w/g, function(txt) {
								return txt.charAt(0).toUpperCase() + txt.substr(1)
							})
						}}
					</p>
					<p><strong>Previous: </strong> {{ his.old_booking_value }}</p>
					<p><strong>Current: </strong> {{ his.new_booking_value }}</p>
					<p><strong>Market Date: </strong> {{ his.market_date }}</p>
					<p><strong>Date: </strong> {{ his.date }}</p>
					<hr />
				</div>
			</v-list-item>

			<v-card-actions v-if="paymentData.stallholder_id && paymentData.stallholder_id > 0">
				<v-spacer></v-spacer>
				<v-btn text :to="`/stallholders/${paymentData.stallholder_id}`">
					View Stallholder Bookings Page
					<v-icon right dark>mdi-open-in-new</v-icon>
				</v-btn>
			</v-card-actions>
		</v-card>

		<BookingsTable v-if="payment_id" :payment_id="payment_id" :key="payment_id" />

		<!-- <StallholderDialog
              :dialogVisible="isStallholderDialogVisible"
              :selectedStallholder="stallholderData"
              @close="closeStallholderDialog"
              @update="updateStallholder"
            /> -->

		<BookingModal :dialogVisible="$store.state.dialogs.booking" :selectedItem="selectedBooking" :key="selectedBooking.id" @close="$store.commit('setDialogVisibility', { dialog: 'booking', value: false })" />
		<!-- <BookingModal
              :dialogVisible="this.$store.state.dialog.booking"
              :selectedStall="selectedBooking"
              :selectedDate="date"
              @close="dialogClose"
              @save="dialogSave"
              @create="createBooking"
              @update="updateBooking"
            /> -->

		<v-overlay :value="isLoading" z-index="1000">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-container>
</template>

<script>
import axios from 'axios'
import BookingsTable from '../components/BookingsTable'
import StallholderDialog from '../components/StallholderDialog'
import BookingModal from '../components/BookingModal'

import { mapGetters } from 'vuex'
import store from '../store'

export default {
	data: () => ({
		payment_id: null,
		isLoading: true,
		isStallholderDialogVisible: false,
		isBookingDialogVisible: false,
		//selectedBookingId: false,
		bookingData: [],
		history: [],
	}),
	components: {
		BookingsTable,
		BookingModal,
		StallholderDialog,
	},
	methods: {
		getHistory() {
			let _this = this
			let headers = new Headers({
				Authorization: `Bearer ${this.$store.state.accessToken}`,
			})

			let options = {
				method: 'GET',
				headers: headers,
			}

			let url = `${process.env.VUE_APP_DOMAIN}/wp-json/wisdom-markets/v1/booking-transfer/${this.payment_id}`

			let history = fetch(url, options)
				.then(function(response) {
					if (!response.ok) {
						throw new Error('Network response was not ok')
					}
					return response.json()
				})
				.then(function(data) {
					_this.history = data
				})
				.catch(function(error) {
					console.error('There was a problem with the fetch operation:', error)
				})
		},
		openStallholderDialog() {
			this.isStallholderDialogVisible = true
		},
		closeStallholderDialog() {
			this.isStallholderDialogVisible = false

			// wait half a sec, before resetting data (otherwise we see the stall name cleared in the booking dialog before the dialog fully transitions)
			// setTimeout(() => {
			//  this.selectedStallholderId = false;
			// }, 500)
		},
		// openEditBookingDialog (id) {
		//   //this.isBookingDialogVisible = true
		//   this.selectedBookingId = id;
		// },
		updateStallholder() {
			console.error('do we need to do anythign herereee?')
		},
	},
	computed: {
		...mapGetters([
			'getBooking',
			'getStallholderById',
			'getStallholderColor',
			'getStallholderName',
			'getDefaultStallholderIdForStall',
			'getCategoryById',
			'getStoreStallholders',
			'getStallName', // this is only used incase the stall name gets updated we want the bookings/market list to be auto updated
		]),

		//  stallholderDataAll() {
		//    return  this.getStoreStallholders;
		//  },
		paymentData() {
			console.warn('ffff', this.payment_id)

			let p = this.$store.state.payments.filter((payment) => payment.id == this.payment_id)

			if (p && p.length > 0) {
				this.isLoading = false
				return { ...p[0] }
			}

			return {}
		},
		selectedBooking() {
			//let booking = this.bookingData.find( booking => this.selectedBookingId == booking.id)
			console.log('whatsttsststtgfff')
			if (this.$store.state.selected.bookingId) return this.getBooking(this.$store.state.selected.bookingId)
			else return false

			//return booking
		},
	},
	watch: {
		getStoreStallholders(newValue, oldValue) {
			console.log(`Updating from ${oldValue} to ${newValue}`)
			console.log({ oldValue })
			console.log({ newValue })
			console.log(this.stallholder_id)
			//this.stallholderData = this.getStallholderById(this.stallholder_id)

			// Do whatever makes sense now
			if (newValue === 'success') {
				this.complex = {
					deep: 'some deep object',
				}
			}
		},
	},
	beforeMount() {
		console.error(this.$route.params.id)
		console.log('parse inin')
		this.payment_id = parseInt(this.$route.params.id)
		this.getHistory()
	},
	beforeRouteUpdate(to, from, next) {
		this.isLoading = true
		console.error('ffffu')
		this.payment_id = parseInt(to.params.id)

		//this.getContent(to.params.uid);
		redirectIfNotPayment(to, from, next)

		next()
	},
}

async function redirectIfNotPayment(to, from, next) {
	console.warn({ to })
	console.log('h2222222222ave all paymentsss' + to.params.id, store.state.have_all_stallholders)
	console.log('getting search for ')
	console.warn(store.getters.getPaymentById(to.params.id))
	if (store.state.have_all_stallholders || store.getters.getPaymentById(to.params.id)) {
		console.log('we have payment datassss for ')
	} else {
		console.log('we need to fetch payment  for ' + to.params.id)

		const user = store
			.dispatch('loadPayment', { id: to.params.id })
			.then(function(response) {
				// yay, you got data
				console.log('fulfilledss')
				console.log({ response })
				store.commit('addPayment', response)

				if (response.stallholder_id && response.stallholder_id > 0) {
					store
						.dispatch('loadStallholder', { id: response.stallholder_id })
						.then(function(stallholderresponse) {
							// yay, you got data
							console.log('fulfilled stallhodler id')
							console.log({ stallholderresponse })
							store.commit('addStallholder', stallholderresponse)
						})
						.catch(function(error) {
							// oops, stallholde rnot found
							console.error('no stallholder data found')
						})
				} else {
					console.log('must be guest booking no fetching required of stallhodler')
				}
			})
			.catch(function(error) {
				// oops, stallholde rnot found
				next({ name: 'payments' })
			})
	}
	next()
}
</script>

<style>
.v-list-item {
	-webkit-user-select: initial;
	-moz-user-select: initial;
	-ms-user-select: initial;
	user-select: initial;
}
</style>
